import { gql } from '@apollo/client';

export const JOB_POSITION_FRAGMENT = gql`
  fragment JobPositionFragment on JobPosition {
    id
    title
    active
    basicSalary
    salaryLow
    employmentTypes
    status
    lastStatusChange
    fullTimeHours
    partTimeHours
    salaryHigh
    showSalary
    salaryLastChangedAt
    vacationDays
    canStartDate
    salaryElements {
      daysPerMonth
      id
      percent
      title
    }
    canStartNow
    geoLocation {
      id
      formattedAddress
      placeId
      location
      postalCode
      city
      country
    }
    contractTypes {
      id
      title
    }
    whatADayLooksLike
    departments {
      id
      name
    }
    educationPayments {
      id
      title
      value
    }
    jobTitles {
      id
      area
      title
      typeOfEmployer
    }
    employer {
      id
      aboutUs
      averagePeriod
      bestArgumentQuote
      careType
      name
      showSalary
      typesLeasingEmployer
      sourceDomains
      formalLanguage
      averageTime
      averagePeriod
      adjustableDistance
      offerApartments
      interviewTypes
      differentiations {
        title
        subtitle
        id
      }
      displayContactPerson {
        id
        jobTitle
      }
      logoKey
      contractSalesEmployeeId
      createdAt
      organisation {
        logoKey
      }
      gallery
      beds
      teamSize
      applicationProcess
      numberOfDoctors
      patients
      overtimeCompensations {
        title
      }
      salaryNegotiations {
        title
      }
    }
    beds
    teamSize
    applicationProcess
    numberOfDoctors
  }
`;

export const MATCH_FRAGMENT = gql`
  fragment MatchFragment on Match {
    id
    invitationText
    isReAcceptable
    documentRequirement
    onlineMatchStatus
    connectionStatus
    connectionType
  }
`;

export const JOB_BOARD_POSITION_FRAGMENT = gql`
  fragment JobBoardPositionFragment on JobPositionForCandidateDto {
    jobPosition {
      ...JobPositionFragment
    }
    match {
      ...MatchFragment
    }
    distance
    score
  }
  ${JOB_POSITION_FRAGMENT}
  ${MATCH_FRAGMENT}
`;

export const JOB_POSITION_SEO_FRAGMENT = gql`
  fragment JobPositionSeoFragment on JobPosition {
    headline
    metaDescription
    organicSessions
  }
`;

export const DIRECTIONS_MAP_FRAGMENT = gql`
  fragment DirectionsMapFragment on JobPosition {
    employer {
      formalLanguage
      patientAreas {
        formattedAddress
        location
        placeId
        zone {
          lat
          lng
        }
      }
    }
    geoLocation {
      id
      city
      country
      formattedAddress
      location
      placeId
      postalCode
      streetAddressAndNumber
      administrativeAreaLevel1
      administrativeAreaLevel2
      administrativeAreaLevel3
      administrativeAreaLevel4
      administrativeAreaLevel5
    }
  }
`;
